import {
  Box,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { makeStyles } from '@mui/styles';
import Avatar from 'antd/es/avatar/avatar';
import { poppins500 } from 'theme/common.style';
import { Contact } from './BuyerRegistration.util';
import { GET_BINDERID } from 'constant/app.config';
import { getApiCall } from 'api/apiService';
import { useContext, useState } from 'react';
import Moxochat from 'component/Moxochat/Moxochat';
import { datacontext } from 'modules/AppLayout/AppLayout';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';

const Link = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_101_2)">
        <path
          d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
          fill="url(#paint0_linear_101_2)"
        />
        <path
          d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
          fill="url(#paint1_linear_101_2)"
        />
        <g clip-path="url(#clip1_101_2)">
          <path
            d="M10.0297 4.3758C10.0297 4.24091 10.0819 4.11154 10.1747 4.01616C10.2675 3.92077 10.3935 3.86719 10.5248 3.86719C10.8401 3.86719 11.1495 3.93229 11.451 4.05639C11.7792 4.19117 12.0317 4.39106 12.2609 4.62604C12.4901 4.86204 12.6846 5.12143 12.8158 5.45864C12.9366 5.76839 13 6.08627 13 6.41026C13 6.73424 12.9366 7.05213 12.8158 7.36187C12.6866 7.69502 12.495 7.95187 12.2693 8.18532L11.7822 8.73615C11.7769 8.74205 11.7714 8.74782 11.7658 8.75344L10.1817 10.381C9.95247 10.6165 9.7 10.8164 9.37178 10.9517C9.07764 11.0749 8.7632 11.139 8.44554 11.1404C8.12786 11.1388 7.81342 11.0746 7.51931 10.9512C7.19109 10.8164 6.93861 10.6165 6.70941 10.3815C6.4802 10.1455 6.28564 9.88612 6.15446 9.54891C6.02965 9.2304 5.96708 8.88977 5.9703 8.54644C5.9703 8.22245 6.03366 7.90457 6.15446 7.59482C6.28564 7.25761 6.4802 6.99821 6.70891 6.76273L7.25347 6.20325C7.29943 6.156 7.354 6.1185 7.41407 6.09292C7.47413 6.06733 7.53851 6.05415 7.60354 6.05412C7.66856 6.0541 7.73295 6.06724 7.79304 6.09278C7.85312 6.11832 7.90772 6.15578 7.95371 6.203C7.99971 6.25022 8.0362 6.30629 8.0611 6.368C8.08601 6.42971 8.09884 6.49586 8.09886 6.56266C8.09889 6.62947 8.0861 6.69562 8.06124 6.75735C8.03638 6.81908 7.99992 6.87518 7.95396 6.92243L7.40941 7.48191C7.24257 7.65331 7.1401 7.80081 7.07376 7.97221C7.00039 8.15435 6.9619 8.34932 6.9604 8.54644C6.9604 8.78854 6.99851 8.97876 7.07376 9.17152C7.1401 9.34293 7.24257 9.49042 7.40941 9.66183C7.57624 9.83323 7.7198 9.93851 7.88663 10.0067C8.0802 10.0865 8.26584 10.1231 8.44554 10.1231C8.62525 10.1231 8.81089 10.0865 9.00446 10.0067C9.17129 9.93851 9.31485 9.83323 9.48168 9.66183L11.0574 8.04291L11.5445 7.49208C11.5499 7.48618 11.5553 7.48041 11.5609 7.47479C11.7277 7.30338 11.8302 7.15589 11.8965 6.98448C11.9743 6.78561 12.0099 6.59488 12.0099 6.41026C12.0099 6.22563 11.9743 6.0349 11.8965 5.83603C11.8302 5.66463 11.7277 5.51713 11.5609 5.34573C11.3941 5.17433 11.2505 5.06904 11.0837 5.00038C10.9064 4.92517 10.7166 4.8858 10.5248 4.88442C10.3935 4.88442 10.2675 4.83083 10.1747 4.73545C10.0819 4.64006 10.0297 4.51069 10.0297 4.3758ZM7.60396 5.13872C7.42426 5.13872 7.23861 5.17534 7.04505 5.25469C6.87822 5.32335 6.73465 5.42863 6.56782 5.60054L4.94257 7.26981L4.45545 7.82064L4.43911 7.83794C4.27228 8.00934 4.1698 8.15684 4.10297 8.32824C4.02977 8.51041 3.99144 8.70538 3.9901 8.90247C3.9901 9.08709 4.02574 9.27782 4.10297 9.47669C4.1698 9.64809 4.27228 9.79559 4.4396 9.96699C4.60594 10.1384 4.7495 10.2437 4.91634 10.3123C5.1099 10.3917 5.29554 10.4283 5.47525 10.4283C5.60654 10.4283 5.73246 10.4819 5.8253 10.5773C5.91814 10.6727 5.9703 10.802 5.9703 10.9369C5.9703 11.0718 5.91814 11.2012 5.8253 11.2966C5.73246 11.3919 5.60654 11.4455 5.47525 11.4455C5.15759 11.4442 4.84315 11.3801 4.54901 11.2568C4.22079 11.1215 3.96832 10.9217 3.73911 10.6862C3.5099 10.4507 3.31535 10.1913 3.18416 9.85408C3.06404 9.55192 3.00152 9.22886 3 8.90247C3 8.57848 3.06337 8.26059 3.18416 7.95085C3.31337 7.61771 3.50495 7.36086 3.73069 7.1274L4.21782 6.57657L4.23416 6.55928L5.86782 4.88086C6.09703 4.64537 6.3495 4.44548 6.67772 4.3107C6.97183 4.18729 7.28627 4.12306 7.60396 4.12149C7.91931 4.12149 8.22871 4.1866 8.5302 4.3107C8.85842 4.44548 9.11089 4.64537 9.3401 4.88035C9.56931 5.11634 9.76386 5.37574 9.89505 5.71295C10.0158 6.02269 10.0792 6.34058 10.0792 6.66456C10.0792 6.98855 10.0158 7.30644 9.89505 7.61618C9.76535 7.94932 9.57376 8.20719 9.34802 8.44014L8.8104 9.04284C8.72164 9.14226 8.59808 9.20138 8.4669 9.2072C8.33571 9.21302 8.20766 9.16506 8.11089 9.07387C8.01413 8.98268 7.95658 8.85574 7.95092 8.72096C7.94526 8.58618 7.99194 8.45461 8.08069 8.3552L8.62525 7.74486L8.6401 7.72909C8.80693 7.55769 8.90941 7.41019 8.97574 7.23879C9.05346 7.03992 9.08911 6.84919 9.08911 6.66456C9.08911 6.47994 9.05346 6.28921 8.97574 6.09034C8.90941 5.91894 8.80693 5.77144 8.6401 5.60004C8.47327 5.42863 8.3297 5.32335 8.16287 5.25469C7.98556 5.17948 7.79579 5.1401 7.60396 5.13872Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_101_2"
          x1="0"
          y1="8"
          x2="16"
          y2="8"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2BC4F3" />
          <stop offset="0.5" stop-color="#00AEEE" />
          <stop offset="1" stop-color="#0095DA" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_101_2"
          x1="0"
          y1="8"
          x2="16"
          y2="8"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2BC4F3" />
          <stop offset="0.5" stop-color="#00AEEE" />
          <stop offset="1" stop-color="#0095DA" />
        </linearGradient>
        <clipPath id="clip0_101_2">
          <rect width="16" height="16" fill="white" />
        </clipPath>
        <clipPath id="clip1_101_2">
          <rect width="10" height="9" fill="white" transform="translate(3 3)" />
        </clipPath>
      </defs>
    </svg>
  );
};
const LegalIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
        fill="url(#paint0_linear_25129_146996)"
      />
      <path
        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
        fill="url(#paint1_linear_25129_146996)"
      />
      <g clip-path="url(#clip0_25129_146996)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.46869 3.46875C8.46869 3.34443 8.41931 3.2252 8.3314 3.13729C8.24349 3.04939 8.12426 3 7.99994 3C7.87562 3 7.75639 3.04939 7.66849 3.13729C7.58058 3.2252 7.53119 3.34443 7.53119 3.46875V4.25H6.91619C6.72557 4.25 6.53869 4.3 6.37307 4.39375L5.56807 4.85438C5.54428 4.86798 5.51734 4.87509 5.48994 4.875H4.09369C3.96937 4.875 3.85014 4.92439 3.76224 5.01229C3.67433 5.1002 3.62494 5.21943 3.62494 5.34375C3.62494 5.46807 3.67433 5.5873 3.76224 5.67521C3.85014 5.76311 3.96937 5.8125 4.09369 5.8125H4.36119L3.04119 8.745C3.0022 8.83176 2.99053 8.92832 3.00772 9.02187C3.02491 9.11542 3.07016 9.20152 3.13744 9.26875V9.26937L3.13869 9.27062L3.13994 9.27187L3.14369 9.27563L3.15369 9.285L3.18182 9.31C3.31326 9.42017 3.45716 9.51456 3.61057 9.59125C4.00413 9.78313 4.43712 9.8803 4.87494 9.875C5.42494 9.875 5.84744 9.7375 6.13932 9.59125C6.29272 9.51456 6.43662 9.42016 6.56807 9.31L6.59619 9.285L6.60619 9.27563L6.60994 9.27187L6.61119 9.27062L6.61182 9.26937L6.28119 8.9375L6.61244 9.26875C6.67973 9.20152 6.72497 9.11542 6.74216 9.02187C6.75935 8.92832 6.74768 8.83176 6.70869 8.745L5.38869 5.8125H5.48994C5.68057 5.8125 5.86744 5.7625 6.03307 5.66875L6.83869 5.20812C6.86229 5.19462 6.889 5.18752 6.91619 5.1875H7.53119V11.125H5.96869C5.84437 11.125 5.72514 11.1744 5.63724 11.2623C5.54933 11.3502 5.49994 11.4694 5.49994 11.5938C5.49994 11.7181 5.54933 11.8373 5.63724 11.9252C5.72514 12.0131 5.84437 12.0625 5.96869 12.0625H10.0312C10.1555 12.0625 10.2747 12.0131 10.3626 11.9252C10.4506 11.8373 10.4999 11.7181 10.4999 11.5938C10.4999 11.4694 10.4506 11.3502 10.3626 11.2623C10.2747 11.1744 10.1555 11.125 10.0312 11.125H8.46869V5.1875H9.08369C9.11088 5.18752 9.13759 5.19462 9.16119 5.20812L9.96744 5.66812C10.1324 5.76312 10.3193 5.8125 10.5099 5.8125H10.6112L9.29119 8.745C9.2522 8.83176 9.24053 8.92832 9.25772 9.02187C9.27491 9.11542 9.32016 9.20152 9.38744 9.26875V9.26937L9.38869 9.27062L9.38994 9.27187L9.39369 9.27563L9.40369 9.285L9.43182 9.31C9.56327 9.42016 9.70717 9.51455 9.86057 9.59125C10.2541 9.78313 10.6871 9.8803 11.1249 9.875C11.6749 9.875 12.0974 9.7375 12.3893 9.59125C12.5427 9.51457 12.6866 9.42018 12.8181 9.31L12.8462 9.285L12.8524 9.27875L12.8562 9.27563L12.8599 9.27187L12.8612 9.27062L12.8618 9.26937L12.5312 8.9375L12.8624 9.26875C12.9297 9.20152 12.975 9.11542 12.9922 9.02187C13.0094 8.92832 12.9977 8.83176 12.9587 8.745L11.6393 5.8125H11.9062C12.0305 5.8125 12.1497 5.76311 12.2376 5.67521C12.3256 5.5873 12.3749 5.46807 12.3749 5.34375C12.3749 5.21943 12.3256 5.1002 12.2376 5.01229C12.1497 4.92439 12.0305 4.875 11.9062 4.875H10.5099C10.4828 4.87498 10.456 4.86788 10.4324 4.85438L9.62619 4.39437C9.46118 4.29998 9.27442 4.25022 9.08432 4.25H8.46869V3.46875ZM4.05932 8.76687C4.23744 8.85125 4.50807 8.9375 4.87494 8.9375C5.24182 8.9375 5.51244 8.85125 5.69057 8.76687L4.87494 6.95438L4.05932 8.76687ZM10.3093 8.76687C10.4874 8.85125 10.7581 8.9375 11.1249 8.9375C11.4918 8.9375 11.7624 8.85125 11.9406 8.76687L11.1249 6.95438L10.3093 8.76687Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_25129_146996"
          x1="0"
          y1="8"
          x2="16"
          y2="8"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2BC4F3" />
          <stop offset="0.5" stop-color="#00AEEE" />
          <stop offset="1" stop-color="#0095DA" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_25129_146996"
          x1="0"
          y1="8"
          x2="16"
          y2="8"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2BC4F3" />
          <stop offset="0.5" stop-color="#00AEEE" />
          <stop offset="1" stop-color="#0095DA" />
        </linearGradient>
        <clipPath id="clip0_25129_146996">
          <rect
            width="10"
            height="10"
            fill="white"
            transform="translate(3 3)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
const AddIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="18" height="18" rx="5" fill="#BCBBBC" fill-opacity="0.1" />
      <path
        d="M9 2.5C9.21549 2.5 9.42215 2.5856 9.57452 2.73798C9.7269 2.89035 9.8125 3.09701 9.8125 3.3125V8.1875H14.6875C14.903 8.1875 15.1097 8.2731 15.262 8.42548C15.4144 8.57785 15.5 8.78451 15.5 9C15.5 9.21549 15.4144 9.42215 15.262 9.57452C15.1097 9.7269 14.903 9.8125 14.6875 9.8125H9.8125V14.6875C9.8125 14.903 9.7269 15.1097 9.57452 15.262C9.42215 15.4144 9.21549 15.5 9 15.5C8.78451 15.5 8.57785 15.4144 8.42548 15.262C8.2731 15.1097 8.1875 14.903 8.1875 14.6875V9.8125H3.3125C3.09701 9.8125 2.89035 9.7269 2.73798 9.57452C2.5856 9.42215 2.5 9.21549 2.5 9C2.5 8.78451 2.5856 8.57785 2.73798 8.42548C2.89035 8.2731 3.09701 8.1875 3.3125 8.1875H8.1875V3.3125C8.1875 3.09701 8.2731 2.89035 8.42548 2.73798C8.57785 2.5856 8.78451 2.5 9 2.5Z"
        fill="#666666"
      />
    </svg>
  );
};

export default function ConnectedContacts(props) {
  const { buyerDetails } = props;
  const params = useParams();
  const propertyId = params?.dashboardId;
  const classes = useStyles();
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const [modalIsOpen, setModalIsOpen] = useState(null);
  const { realTimeLog, setIschatopen } = useContext(datacontext);

  const onShowChat = (binderId) => {
    setIschatopen(binderId);
    setModalIsOpen(binderId);
  };

  const directcomm = (userId) => {
    const data = localStorage.getItem('userDetail');
    const userDetail = JSON.parse(data);
    const agentId = userDetail?.userId;
    const userType = userDetail?.primaryUserType;

    if (userId) {
      getApiCall(
        GET_BINDERID +
          `/${agentId}` +
          `/${userId}` +
          `/${propertyId}` +
          `/${userType}`
      ).then((resp) => {
        onShowChat(resp?.data?.binderId);
      });
    }
  };

  function CircularProgressWithProfile(props) {
    return (
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <CircularProgress
          variant="determinate"
          value={100}
          sx={{ color: '#C4C4C461' }}
          thickness={5}
          size={45}
        />
        <CircularProgress
          variant="determinate"
          value={props.value}
          sx={{ color: '#10D35E', position: 'absolute' }}
          thickness={5}
          size={45}
        />
        <Box
          sx={{
            top: '50%',
            left: '53%',
            transform: 'translate(-50%, -50%)',
            position: 'absolute',
          }}
        >
          <Typography
            variant="caption"
            component="div"
            sx={{ color: '#000000', ...poppins500, fontSize: '14px' }}
          >
            {props.profileImage == '' || props.profileImage == null ? (
              <Avatar
                style={{
                  width: '36px',
                  height: '36px',
                  backgroundColor: '#666666',
                  fontFamily: 'poppins',
                }}
              >
                {props?.firstName?.charAt(0)?.toUpperCase() +
                  props?.lastName?.charAt(0)?.toUpperCase()}
              </Avatar>
            ) : (
              <Avatar
                alt="Remy"
                src={props?.profileImage}
                style={{
                  width: '36px',
                  height: '36px',
                }}
              />
            )}
          </Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Grid
      className={classes.ConnectedDiv}
      sx={{
        marginLeft: matchessm ? '0px' : '13px',
        marginTop: matchessm ? '0px' : '35px',
        width: matchessm ? '100%' : '340px',
      }}
    >
      <Grid
        className={classes.HeaderBackground}
        direction="row"
        align-items="flex-start"
        sx={{ width: matchessm ? '100%' : 'auto' }}
      >
        <Typography className={classes.HeaderText} sx={{ fontSize: '14px' }}>
          Connected Contacts
        </Typography>
      </Grid>

      {/* Linked Partners Section */}
      <Grid
        className={classes.ChildLable}
        sx={{ width: matchessm ? '100%' : 'auto' }}
      >
        <Grid
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '0 6px',
          }}
        >
          <Box sx={{ display: 'flex', gap: '5px' }}>
            <Link />
            <Typography
              sx={{ fontSize: '12px', fontFamily: 'poppins', fontWeight: 400 }}
            >
              Linked Partner ({buyerDetails?.linkedBuyers?.length || 0})
            </Typography>
          </Box>
          <Box>
            <IconButton>
              <AddIcon border={'#666666'} />
            </IconButton>
          </Box>
        </Grid>
        <Grid>
          {buyerDetails?.linkedBuyers?.length > 0 ? (
            buyerDetails?.linkedBuyers?.map((item, index) => (
              <Grid
                key={index}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-around',
                  margin: '10px 0',
                }}
              >
                <Grid
                  sx={{ display: 'flex', alignItems: 'center', gap: '15px' }}
                >
                  <Grid>
                    <CircularProgressWithProfile
                      value={buyerDetails?.profileActivity}
                      profileImage={
                        item?.userProfile || item?.user?.userProfile
                      }
                      firstName={
                        item?.userName || item?.name || item?.firstName
                      }
                      lastName={
                        item?.userSurName || item?.surname || item?.lastName
                      }
                    />
                  </Grid>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontFamily: 'poppins',
                      fontWeight: '400',
                      width: '80px',
                      textOverflow: 'ellipsis',
                      overflow: 'auto',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {item?.userName ||
                      item?.name ||
                      `${item?.firstName || ''} ${item?.lastName || ''}`}
                  </Typography>
                </Grid>
                <Grid>
                  <Contact row={item} index={null} />
                </Grid>
              </Grid>
            ))
          ) : (
            <Grid
              xs={12}
              sm={12}
              lg={12}
              sx={{
                textAlign: 'center',
                fontFamily: 'poppins',
                color: '#585858',
                alignItems: 'center',
                paddingTop: '20px',
                fontSize: '12px',
              }}
            >
              Linked Partners not found
            </Grid>
          )}
        </Grid>
      </Grid>

      {/* Legal Representative Section */}
      <Grid
        className={classes.ChildLable}
        sx={{ width: matchessm ? '100%' : 'auto' }}
      >
        <Grid
          sx={{
            display: 'flex',
            gap: '5px',
            alignItems: 'center',
            padding: '5px 7px',
          }}
        >
          <LegalIcon />
          <Typography
            sx={{ fontSize: '12px', fontFamily: 'poppins', fontWeight: 400 }}
          >
            Legal Representative
          </Typography>
        </Grid>
        <Grid>
          {buyerDetails?.solicitorDetails?.length > 0 ? (
            buyerDetails?.solicitorDetails?.map((solicitor, index) => (
              <Grid
                key={index}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-around',
                  margin: '10px 0',
                }}
              >
                <Grid
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '15px',
                  }}
                >
                  <Grid>
                    <CircularProgressWithProfile
                      value={buyerDetails?.profileActivity}
                      profileImage={solicitor?.profileImage}
                      firstName={solicitor?.bsName}
                      lastName={solicitor?.bsSurname}
                    />
                  </Grid>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontFamily: 'poppins',
                      fontWeight: '400',
                      width: '130px',
                      textOverflow: 'ellipsis',
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {`${solicitor?.bsName || ''} ${solicitor?.bsSurname || ''}`}
                  </Typography>
                </Grid>
                <Grid>
                  <Contact
                    row={{
                      ...solicitor,
                      userId: solicitor?.bsId,
                      userName: solicitor?.bsName,
                      userSurName: solicitor?.bsSurname,
                      userMobile: solicitor?.bsMobile,
                      userEmail: solicitor?.bsEmail,
                      userProfile: solicitor?.profileImage,
                    }}
                    directcomm={() => onShowChat(solicitor?.binderId)}
                    index={null}
                  />
                </Grid>
              </Grid>
            ))
          ) : (
            <Grid
              xs={12}
              sm={12}
              lg={12}
              sx={{
                textAlign: 'center',
                fontFamily: 'poppins',
                color: '#585858',
                alignItems: 'center',
                paddingTop: '20px',
                paddingBottom: '20px',
                fontSize: '12px',
              }}
            >
              Legal Representative not found
            </Grid>
          )}
        </Grid>
        {modalIsOpen && (
          <Moxochat
            key={modalIsOpen}
            binderId={modalIsOpen}
            open={modalIsOpen}
            onClose={setModalIsOpen}
          />
        )}
      </Grid>
    </Grid>
  );
}

const useStyles = makeStyles((theme) => ({
  ConnectedDiv: {
    marginLeft: '13px',
    padding: '15px',
    border: '1px solid #E7E5E5',
    borderRadius: '10px',
    width: '340px',
    minHeight: '300px',
    marginBottom: '20px',
    marginTop: '35px',
  },
  HeaderText: {
    textAlign: 'center',
    fontFamily: 'Poppins !important',
    fontStyle: 'normal !important',
    fontWeight: '500 !important',
    fontSize: '14px',
    color: '#26344E',
    fontStyle: 'normal',
  },
  HeaderBackground: {
    width: '307px',
    height: '38px',
    background: '#F7F8F7',
    borderRadius: '6px',
    marginTop: '2px',
    marginRight: '10px',
    padding: '8px 12px',
  },
  ChildLable: {
    width: '307px',
    minHeight: '97px',
    borderRadius: '8px',
    marginTop: '2px',
    border: '1px solid #E7E5E5',
    marginTop: '16px',
    color: '#112347',
  },
}));
